const AREAS = [
	["drinkingSobriety", "Drinking/Sobriety"],
	["jobEducation", "Job or Educational Progress"],
	["moneyManagement", "Money Management"],
	["socialLife", "Social Life"],
	["personalHabits", "Personal Habits"],
	["familyRelationships", "Marriage/Family Relationships"],
	["legalIssues", "Legal Issues"],
	["emotionalLife", "Emotional Life"],
	["communication", "Communication"],
	["generalHappiness", "General Happiness"],
]

export function createHappinessScaleConfig() {
	return {
		title: "Happiness Scale",
		instructions: "Rate how happy you feel with each area of your life today. Exclude yesterday's feelings and rate each area independently.",
		scaleMin: 1,
		scaleMax: 10,
		ratingProfile: {
			question: "How happy am I with this area of my life?",
			lowAnchor: "Completely unhappy",
			highAnchor: "Completely happy",
			scoringMethod: "none",
		},
		items: AREAS.map(([id, title]) => ({id, title, practitionerNote: ""})),
	}
}

export function createHappinessScaleDemoPayload() {
	const config = createHappinessScaleConfig()
	const ratings = [4, 6, 5, 7, 5, 8, 9, 5, 6, 7]
	return {
		itemList: config,
		itemState: Object.fromEntries(config.items.map((area, index) => [area.id, {rating: ratings[index], note: ""}])),
		administrationDate: "2026-10-26",
		respondentName: "Alex Morgan",
	}
}

export function createHappinessScaleDemoPriorResults() {
	const payload = createHappinessScaleDemoPayload()
	payload.itemState.personalHabits.rating = 3
	payload.administrationDate = "2026-10-12"
	return [{id: "earlier-administration", enginePayload: payload}]
}
